import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const PreferencesTab = ({ tripData, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    dietaryRestrictions: tripData?.dietaryRestrictions || ''
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    const result = await onUpdate({
      dietaryRestrictions: formData?.dietaryRestrictions?.trim() || null
    });
    setSaving(false);
    
    if (result?.success) {
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      dietaryRestrictions: tripData?.dietaryRestrictions || ''
    });
    setIsEditing(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold" style={{ color: 'var(--color-text-primary)' }}>
          Meal Planning Preferences
        </h2>
        {!isEditing && (
          <Button
            onClick={() => setIsEditing(true)}
            variant="outline"
            size="sm"
          >
            <Icon name="Edit" size={16} />
            <span className="ml-2">Edit</span>
          </Button>
        )}
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-text-primary)' }}>
            Dietary Restrictions
          </label>
          <Input
            name="dietaryRestrictions"
            value={formData?.dietaryRestrictions}
            onChange={handleChange}
            disabled={!isEditing}
            placeholder="e.g., Vegetarian, Gluten-free, Dairy-free"
          />
          <p className="text-xs text-muted-foreground mt-1">
            Enter any dietary restrictions or preferences to customize meal suggestions
          </p>
        </div>

        <div className="p-4 rounded-lg" style={{ backgroundColor: 'var(--color-background)' }}>
          <h3 className="text-sm font-medium mb-2" style={{ color: 'var(--color-text-primary)' }}>
            Leftover Optimization
          </h3>
          <p className="text-xs text-muted-foreground">
            GalleyPlan automatically suggests meals that utilize leftover ingredients to minimize waste and maximize efficiency during your coastal cruise.
          </p>
        </div>

        <div className="p-4 rounded-lg" style={{ backgroundColor: 'var(--color-background)' }}>
          <h3 className="text-sm font-medium mb-2" style={{ color: 'var(--color-text-primary)' }}>
            Equipment-Based Suggestions
          </h3>
          <p className="text-xs text-muted-foreground">
            Meal templates are filtered based on your available cooking equipment. Update your equipment configuration in the Cooking Equipment tab to see different meal options.
          </p>
        </div>
      </div>

      {isEditing && (
        <div className="flex gap-3 pt-4">
          <Button onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save Changes'}
          </Button>
          <Button onClick={handleCancel} variant="outline" disabled={saving}>
            Cancel
          </Button>
        </div>
      )}
    </div>
  );
};

export default PreferencesTab;